/**
 * collection-grid.js 修正版（Swiper初期化高速化）
 * Version: optimized 2025-10-22
 */



function initCollectionSliders() {
  const grids = document.querySelectorAll('.collection-grid');

  if (!grids.length) return;

  grids.forEach((grid, index) => {
    const swiperEl = grid.querySelector('.swiper');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    const swiperParams = {
      slidesPerView: 3.3,
      spaceBetween: 24,
      loop: true,
      speed: 5000,
      autoplay: {
        delay: 0000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: grid.querySelector('.swiper-button-next'),
        prevEl: grid.querySelector('.swiper-button-prev'),
      },
      lazyPreloadPrevNext: 1,
      observer: true,
      observeParents: true,
    };

    // Swiper初期化
    const swiper = new Swiper(swiperEl, swiperParams);

    // 初期化完了後に即表示（opacity無効化保険）
    swiperEl.style.opacity = '1';
    swiperEl.style.visibility = 'visible';
  });
}

// Swiper初期化を画像ロード待ちにしない
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initCollectionSliders, { timeout: 1000 });
    } else {
      setTimeout(initCollectionSliders, 500);
    }
  });
} else {
  initCollectionSliders();
}

// Shopify Theme Editor対応
document.addEventListener('shopify:section:load', initCollectionSliders);

// ▼ 緩急なしの動きをCSSで適用
const style = document.createElement('style');
style.innerHTML = `
  .swiper-wrapper {
    transition-timing-function: linear !important;
  }
`;
document.head.appendChild(style);



